<a [routerLink]="['/petitions', petition?.slug]" class="petition-link">
  @if (placeholder) {
    @if (image) {
      <div role="img">
        <span></span>
      </div>
    }
    <div class="petition">
      <div class="petition__open">
        <span class="placeholder"></span>
      </div>
      <h3><span class="placeholder"></span></h3>
      <p><span class="placeholder"></span></p>
      <tyt-goal-progress mode="bar" [placeholder]="true" noBadges></tyt-goal-progress>
    </div>
    @if (info) {
      <div class="info">
        <span>{{ petition.type }}</span>
        <span>{{ petition.status }}</span>
        <span>TYT Staff</span>
        <button class="none" (click)="deletePetition()">delete</button>
      </div>
    }
  }
  @if (!placeholder) {
    @if (image && petition.image) {
      <div role="img">
        <span [responsiveBackgroundImage]="petition.image"></span>
      </div>
    }
    <div class="petition">
      @if (petition.status == 'closed') {
        <div class="petition__closed">
          Closed
        </div>
      } @else {
        <div class="petition__open">
          Open
        </div>
      }
      <h3>{{ petition.title }}</h3>
      @if (petition.questions?.[0]?.body) {
        <p>{{ petition.questions?.[0]?.body }}</p>
      }
      <tyt-goal-progress mode="bar" [petition]="petition" noBadges></tyt-goal-progress>
    </div>
    @if (info) {
      <div class="info">
        <span>{{ petition.type }}</span>
        <span>{{ petition.status }}</span>
        <span>TYT Staff</span>
        <button class="none" (click)="deletePetition()">delete</button>
      </div>
    }
  }
</a>
